export default __webpack_public_path__ + "static/media/gitlab-logo.ca47d4df.png";